import { getAllGymAccessEventsApiCall, getProviderGymAccessRulesApiCall, saveProviderGymAccessRulesApiCall } from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { GYM_ACCESS_EVENTS_GET_MANY, GYM_ACCESS_RULES_GET, GYM_ACCESS_RULES_SAVE } from '../types';

const getAllGymAccessEvents = () => async dispatch => execute(dispatch, () => getAllGymAccessEventsApiCall(), GYM_ACCESS_EVENTS_GET_MANY);

const getProviderGymAccessRules = () => async dispatch => execute(dispatch, () => getProviderGymAccessRulesApiCall(), GYM_ACCESS_RULES_GET);

const saveProviderGymAccessRules = rules => async dispatch =>
  execute(dispatch, () => saveProviderGymAccessRulesApiCall({ rules }), GYM_ACCESS_RULES_SAVE, true);

export { getAllGymAccessEvents, getProviderGymAccessRules, saveProviderGymAccessRules };
